import { render } from "./ItemRecap.vue?vue&type=template&id=6c59b1da"
import script from "./ItemRecap.vue?vue&type=script&lang=js"
export * from "./ItemRecap.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__